<template>
  <v-card class="progress-status border">
    <journey-goal-setting-tabs />
    <router-view></router-view>
  </v-card>
</template>

<script>
import JourneyGoalSettingTabs from "../../../components/Parts/JourneyGoalSettingTabs";

/**
 * Component ProgressGoalSetting.vue
 *
 * @module ProgressGoalSetting
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/views/Patient/Progress/ProgressGoalSetting.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "ProgressGoalSetting",
  components: {
    JourneyGoalSettingTabs,
  },
};
</script>